export default __webpack_public_path__ + "static/media/Img0019.ecad5287.png";